<template>
    <nav class="border-t border-minplan-beige mt-4 px-4 flex items-center sm:px-0" v-if="links.length > 3">
        <div class="flex justify-between md:-mt-px w-full">

            <div class="w-2/8">
                <template v-for="(link, key) in links">       
                    <Link v-if="link.type === 'prev'" :key="key" :href="link.url" class="border-t-2 border-transparent pt-4 pl-1 inline-flex items-center text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300" v-html="link.label" />
                </template>
            </div>

            <div class="hidden md:flex w-4/8">
                <template v-for="(link, key) in links">      
                    <Link v-if="link.type === 'number'" :key="key+'e'" class="hidden md:flex border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium" 
                            :class="{ 'border-minplan-blue text-minplan-blue border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium': link.active }" :href="link.url" v-html="link.label" />
                </template>
            </div>

            <div class="w-2/8">
                <template v-for="(link, key) in links"> 
                    <Link v-if="link.type === 'next'" :key="key" :href="link.url" class="border-t-2 border-transparent pt-4 pl-1 inline-flex items-center text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300" v-html="link.label" />
                </template>
            </div>

        </div>
    </nav>

</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import { ArrowNarrowLeftIcon, ArrowNarrowRightIcon, } from "@heroicons/vue/outline";

export default {
    name: "Pagination",
    props: {
        links: Array
    },
    components: {
        Link,
        ArrowNarrowLeftIcon, 
        ArrowNarrowRightIcon,
    }
};
</script>

<style scoped>

</style>
